import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { throttle } from 'lodash';
import classNames from 'classnames/bind';
import FilterPanelConnected from '../FilterPanel/FilterPanel';
import styles from './FilterContent.css';

const cx = classNames.bind(styles);

const FilterContent = () => {
    const [filterContentOffset, setFilterContentOffset] = useState(null);

    const {
        context: {
            deviceType: { isDesktop = true, isMobile = false, isTablet = false } = {},
            featureFlags: { enableStickyFacet = false } = {},
        } = {},
        productSettings: { isFacetOpened = false } = {},
        sliderStatus = false,
    } = useSelector((store) => store);

    const filterContentRef = useRef(null);
    const isMobileView = isMobile || (isTablet && sliderStatus);

    /* istanbul ignore next */
    useEffect(() => {
        const handleScroll = throttle(() => {
            const header = document.querySelector('header') || {};
            const promotionalBanner = document.querySelector('#primaryHeader') || {};
            const galleryProductList = document.querySelector('#gallery-product-list') || {};
            const headerPosition = getComputedStyle(header).position;

            if (header.getBoundingClientRect().bottom < 0) setFilterContentOffset(0);
            else if (
                headerPosition === 'sticky' &&
                header.offsetTop !== promotionalBanner.clientHeight
            )
                setFilterContentOffset(header.clientHeight);
            else setFilterContentOffset(galleryProductList.offsetTop);
        }, 50);

        if (enableStickyFacet) {
            document.addEventListener('scroll', handleScroll);

            return () => {
                document.removeEventListener('scroll', handleScroll);
            };
        }

        return undefined;
    }, [filterContentOffset]);

    return (
        !isMobileView &&
        isFacetOpened && (
            <div
                className={[
                    'lg:block',
                    'p-0',
                    'xl:block',
                    cx('wrapper', {
                        fixed: enableStickyFacet,
                        hidden: !sliderStatus,
                        'md:block': isDesktop,
                    }),
                ].join(' ')}
                ref={filterContentRef}
                style={{
                    top: enableStickyFacet ? filterContentOffset : null,
                }}
            >
                <FilterPanelConnected />
            </div>
        )
    );
};

export default FilterContent;
